export default __webpack_public_path__ + "408fbbb09629465f63e1aec5fda997e6.png";